import { render, staticRenderFns } from "./SpecificationCreateEdit.vue?vue&type=template&id=4c468312&"
import script from "./SpecificationCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SpecificationCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports